export default "__VITE_ASSET__e2d0397e__"